import { Pipe, PipeTransform } from '@angular/core';
@Pipe({
  name: 'desanitize',
  standalone: true,
})
export class DesanitizePipe implements PipeTransform {
  transform(value: string): string {
    return value
      .split('-')
      .map((word) => this.decodeEntities(word))
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  }

  private decodeEntities(str: string): string {
    return str
      .replace(/&lt;/g, '<')
      .replace(/&gt;/g, '>')
      .replace(/&amp;/g, '&');
  }
}
